import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalInvoiceFilterProps {}

const ModalInvoiceFilter = ({}: ModalInvoiceFilterProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;

  const isOpen = getModal('single.filterInvoice');

  const onClose = () => {
    closeSingleModal('filterInvoice');
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle={'Filtro de invoices'}
      height={'calc(100vh - 70px)'}
      width={'550px'}
      alignment="right"
    >
      <Form.Export.Invoice.Filter />
    </Modal>
  );
};

export default ModalInvoiceFilter;
